module.exports = __webpack_public_path__ + "img/duplicated.7b2b7c5b.png";